import Vue from "vue";
import VueRouter from "vue-router";
import PromotionRoutes from "./PromotionRoutes";
import $store from "@/store";
import MallRoutes from "./MallRoutes";
import ShopCheckRoutes from "./ShopCheckRoutes";
import DrawRoutes from "./DrawRoutes";
import StarLevelRoutes from "./StarLevelRoutes";
import BountyRoutes from "./BountyRoutes";
import IntegralRoutes from "./IntegralRoutes";
import ArticleRoutes from "./ArticleRoutes";
import QARoutes from "./QARoutes";
import K1PromotionRoutes from "./K1PromotionRoutes";
import OwnerRouters from "./OwnerRouters";
import WarehouseRoutes from "./WarehouseRoutes";
import { getToken } from "@/utils/request";
import ActivityRoutes from "./ActivityRoutes";
import ProtocolRoutes from "./ProtocolRoutes";
import TbrScanRouter from "./TbrScanRouter";
import {
  beforeRouteForPageTransition,
  updateRouteStack
} from "@/plugins/router/PageTransition";
import GetCouponsRoutes from "./GetCouponsRoutes";
import { hasMatchRoute } from "@/utils/router";
import { isMalaysia } from "@/utils/country";
import TaskDetailRouters from "./TaskDetailRouters";
import AnnualBillRouters from "./AnnualBillRouters";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

const routes = [
  // {
  //   path: "/",
  //   meta: { unusedToken: true }
  // },
  // {
  // path: "/",
  // name: "home",
  // meta: { includeStatusBar: true },
  // component: () => import("../views/home/index.vue")
  // },
  {
    path: "/page/TBR-home",
    name: "TBRHome",
    meta: { includeStatusBar: true },
    component: () => import("../views/home/index.vue")
  },

  {
    path: "/page/plp/:id",
    name: "PagePLP",
    meta: { title: "活动商品" },
    component: () => import("../views/pages/PagePLP.vue")
  },
  {
    path: "/login-test", // 内部登录
    name: "loginTest",
    meta: {
      title: "Login",
      unusedToken: true
    },
    component: () => import("../views/login/index.vue")
  },
  {
    path: "/app-download",
    name: "PCRAppDownload",
    meta: {
      title: "门店通下载",
      unusedToken: true
    },
    component: () => import("../views/download/PCRAppDownload.vue")
  },
  {
    path: "/wt-cn-app-download",
    name: "WTAppDownload",
    meta: {
      title: "下载赢在一起APP",
      unusedToken: true
    },
    component: () => import("../views/download/WTAppDownload.vue")
  },
  {
    path: "/k1-app-download",
    name: "K1AppDownload",
    meta: {
      title: "K1扫码枪下载页",
      unusedToken: true
    },
    component: () => import("../views/download/K1AppDownload.vue")
  },
  {
    path: "/page/:id",
    name: "page",
    meta: { showHeader: false, unusedToken: true },
    component: () => import("../views/pages/Page.vue")
  },
  // 文章
  ...ArticleRoutes,
  // 秒杀活动
  ...PromotionRoutes,
  // wt商城——小胎，PCR
  ...MallRoutes,
  // 店检
  ...ShopCheckRoutes,
  // 抽奖
  ...DrawRoutes,
  // 星级
  ...StarLevelRoutes,
  // 奖励金
  ...BountyRoutes,
  // 积分
  ...IntegralRoutes,
  // Q&A
  ...QARoutes,
  // k1促销
  ...K1PromotionRoutes,
  // 车主服务
  ...OwnerRouters,
  // 出入库
  ...WarehouseRoutes,
  // 常规促销
  ...ActivityRoutes,
  // 直领活动
  ...GetCouponsRoutes,
  //任务详情
  ...TaskDetailRouters,
  //年度账单
  ...AnnualBillRouters,
  //协议
  ...ProtocolRoutes,
  // 大胎扫码
  ...TbrScanRouter
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
// 不显示statusBar的页面
export const includeStatusBarRoutes = routes
  .map((o: any) => o?.meta?.includeStatusBar && o)
  .filter(Boolean);

// 缓存的路由
export const needCacheRoutes = routes
  .map((o: any) => o?.meta?.keepAlive && o.name)
  .filter(Boolean);

// 不需要token认证的路由
export const unusedTokenRoutes = routes
  .map((o: any) => o?.meta?.unusedToken && o)
  .filter(Boolean);
// console.log(includeStatusBarRoutes, unusedTokenRoutes, needCacheRoutes);

router.beforeEach(async (to, from, next) => {
  // 更新路由栈
  updateRouteStack.call(router, to, from);

  // 设置page动画
  beforeRouteForPageTransition.call(router, to, from);

  // 特殊处理，当路由一样，就返回首页
  if (to.fullPath === from.fullPath) {
    window.nativeApp?.backToHome();
    next();
    return;
  }
  // 设置页面title
  const routerTitle = to?.meta?.title;
  if (routerTitle) {
    $store.commit("app/saveTitleMutation", routerTitle);
  }

  // 没有品牌，佳安，佳通，就获取
  if (!hasMatchRoute(router, unusedTokenRoutes, to.path)) {
    // 首先获取token
    await getToken();
    await $store.dispatch("app/getPlatformAction");
  }

  next();
});

export default router;
